module.exports = __webpack_public_path__ + "static/img/US.3dfd5a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/img/countries/US.svg
// module id = j5yv
// module chunks = 1